import { render } from "./lang-sel.vue?vue&type=template&id=3e3aa3f1"
import script from "./lang-sel.vue?vue&type=script&lang=js"
export * from "./lang-sel.vue?vue&type=script&lang=js"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__